import React, { useState, useEffect } from 'react';
import ClipBoardPresenter from './ClipBoardPresenter';

import {
  ReceivedQuotationDesignForm,
  ReceivedQuotationNormalForm
} from '@components/Form';
import LoadingPresenter from '@components/Loading';

import queryString from 'query-string';

import { useHistory, useLocation } from 'react-router-dom';

import {
  CapaQuotationServiceType,
  useFetchRfqQuotationPdfQuery
} from '@generated/graphql';
import { QuotationCommonWrapper } from '@components/Form/ReceivedQuotationForm';

interface QueryStringProps {
  quotationId?: string;
  rfqId?: string;
}

const uuidV4Regex = /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

const ClipBoardContainer = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const query: QueryStringProps = queryString.parse(search);

  const [queries, setQueries] = useState<QueryStringProps | undefined>(
    undefined
  );

  const isQuotation = pathname.includes('quotation');

  const {
    data: quotationInfo,
    loading: quotationLoading,
    error: quotationError
  } = useFetchRfqQuotationPdfQuery({
    variables: {
      input: {
        quotationId: queries?.quotationId ?? ''
      }
    },
    skip: !isQuotation || !queries?.quotationId
  });

  const quotation = quotationInfo?.fetchRfqQuotationPdf.data;

  const designServiceType =
    CapaQuotationServiceType.Design ===
    (quotation?.serviceType as CapaQuotationServiceType);

  const loading = quotationLoading;

  useEffect(() => {
    if (query.quotationId && query.rfqId) {
      const isValid = [query.quotationId, query.rfqId].filter(
        (v) => !uuidV4Regex.exec(v)
      );

      if (isValid.length > 0) {
        return history.replace('/notfound');
      }

      if (isValid.length === 0) {
        setQueries({
          quotationId: query.quotationId,
          rfqId: query.rfqId
        });
      }
    }
  }, [history, query.quotationId, query.rfqId]);

  useEffect(() => {
    if (quotationError) {
      return history.replace('/notfound');
    }
  }, [quotationError, history]);

  if (loading) return <LoadingPresenter open />;

  return (
    <QuotationCommonWrapper
      isClosedConsulting={false}
      rfqId={query.rfqId}
      quotationId={query.quotationId}
    >
      <ClipBoardPresenter
        isQuotation={isQuotation}
        quotationForm={
          designServiceType ? (
            <ReceivedQuotationDesignForm
              {...quotation}
              rfqId={queries?.rfqId}
              haveConsulted={true}
            />
          ) : (
            <ReceivedQuotationNormalForm
              {...quotation}
              rfqId={queries?.rfqId}
              haveConsulted={true}
            />
          )
        }
      />
    </QuotationCommonWrapper>
  );
};

export default ClipBoardContainer;
